import { render } from "./GenerateFile.vue?vue&type=template&id=d230f0ca"
import script from "./GenerateFile.vue?vue&type=script&lang=js"
export * from "./GenerateFile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/callum/Dev/saxton/saxton-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__